import { render, staticRenderFns } from "./Distinguish.vue?vue&type=template&id=3c35b038&scoped=true"
import script from "./Distinguish.vue?vue&type=script&lang=js"
export * from "./Distinguish.vue?vue&type=script&lang=js"
import style0 from "./Distinguish.vue?vue&type=style&index=0&id=3c35b038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35b038",
  null
  
)

export default component.exports